import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Typography } from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';

const CategoryFilter = ({ categories, onChange, selected }) => (
  <Grid
    className="ie-grid-four-col"
    component="ol"
    columns="repeat(auto-fill, minmax(240px, 1fr))"
    rowGap="medium"
    columnGap="medium"
    style={{
      listStylePosition: 'outside',
      listStyleType: 'none',
      margin: 0,
      padding: 0,
    }}
  >
    {selected && (
      <li>
        <Button onClick={() => onChange(null)} theme="text" type="button" tabIndex={0}>
          <Typography preset="subtitle--small" color="dustygrey">
            <Trans i18nKey="news:clear_categories_filter">Clear</Trans>
          </Typography>
        </Button>
      </li>
    )}
    {categories.map((category) => (
      <Typography key={category.value} color="primary">
        <li style={{ listStyleType: selected === category.value ? 'disc' : 'none' }}>
          <Button onClick={() => onChange(category.value)} theme="text" type="button" tabIndex={0}>
            <Typography preset="subtitle--small" color="dustygrey">
              {category.label}
            </Typography>
          </Button>
        </li>
      </Typography>
    ))}
  </Grid>
);

CategoryFilter.defaultProps = {
  selected: null,
};

CategoryFilter.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CategoryFilter;
